import { query } from '@confluence/query-preloader-tools/entry-points/graphql.ts';

import CoverPictureQuery, {
	type CoverPictureQuery$data,
	type CoverPictureQuery$variables,
} from '../__generated__/CoverPictureQuery.graphql.ts';

export function preloadEditorPageCoverPicture(
	contentId: CoverPictureQuery$variables['contentId'],
	draftShareId: CoverPictureQuery$variables['draftShareId'],
	useCache: boolean,
) {
	return query<CoverPictureQuery$data, CoverPictureQuery$variables>({
		query: CoverPictureQuery,
		variables: {
			contentId,
			status: ['current', 'draft'],
			draftShareId,
		},
		fetchPolicy: useCache ? 'cache-first' : 'network-only',
	});
}
